<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          .text-md.font-semibold.text-center.neutral700--text Register patient
        v-col(cols="1" align="right")
          v-btn(icon @click="closeDialog" small color="primary")
            v-icon mdi-close
    v-divider
    v-card-text.pa-6
      div.text-sm.font-medium.neutral700--text Choose visit purpose
      v-radio-group(v-model="purpose" row)
        v-radio(value="consultation")
          template(#label)
            .text-md.neutral700--text Consultation
        v-radio(value="otc")
          template(#label)
            .text-md.neutral700--text OTC
      div.text-sm.font-medium.neutral700--text Search existing patient
      search-patient-dropdown.mt-2(v-model="objPatient" @change="addExistingPatient")

      .py-4.text-center.font-semibold.neutral700--text OR
      v-row.pb-3
        v-col
          y-button(@click="showReaderDialog = true" label="Read from MyKad" color="neutral300" prepend-icon="$yzi-scan" block)
        v-col
          y-button(label="Add new patient" color="neutral300" prepend-icon="$yzi-user-plus-01" block @click="addNewPatient")
  
    .dialogs
      // New registration dialogs
      register-patient-dialog(v-if="openRegisterPatientDialog" :open.sync="openRegisterPatientDialog" :existing-patient.sync="patient" :purpose-data="purpose" :prefill-data="prefillData" @updated="closeDialog" @downgraded="handleDowngraded")
      // Old registration dialogs (remove when not needed)
      old-register-patient-dialog(v-if="openOldRegisterPatientDialog" :open.sync="openOldRegisterPatientDialog" :existing-patient.sync="patient" :purpose="purpose" :prefill-data="prefillData" @updated="closeDialog" @upgraded="handleUpgraded")

      my-kad-reader-dialog(v-if="showReaderDialog" :open.sync="showReaderDialog" @complete="processCardData")

</template>

<script>
import { debounce } from '@/utils'
import { mapState, mapGetters, mapActions } from 'vuex'
import SearchPatientDropdown from '@/components/clinic/registration/SearchPatientDropdown.vue'
import NewRegisterPatientDialog from '@/components/clinic/registration/NewRegisterPatientDialog.vue'
import RegisterPatientDialog from '@/components/clinic/registration/RegisterPatientDialog.vue'
import MyKadReaderDialog from '@/components/clinic/registration/MyKadReaderDialog.vue'
import OldRegisterPatientDialog from '@/components/clinic/registration/NewRegisterPatientDialog.vue'

export default {
  components: { SearchPatientDropdown, NewRegisterPatientDialog, RegisterPatientDialog, MyKadReaderDialog, OldRegisterPatientDialog },
  props: {
    open: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    isFetching: false,
    openRegisterPatientDialog: false,
    openOldRegisterPatientDialog: false,
    searchPatient: null,
    patient: null,
    objPatient: null,
    purpose: 'consultation',
    patients: [],
    showReaderDialog: false,
    prefillData: false,
  }),
  computed: {
    ...mapState('user', ['member']),
    ...mapGetters({ company: 'getCompany' }),
    showDialog: {
      get () {
        return this.open 
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    },
  },
  watch: {
    searchPatient () {
      this.searchStart()
    }
  },
  mounted () {
    this.fetchPatients()
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchPatients () {
      this.isFetching = true
      const params = {
       fields: 'id,name,phone,ic',
       search: this.searchPatient
      }
      this.$axios.get(`/clinics/${this.company.slug}/patients`, { params })
        .then(resp => {
          this.patients = resp.data.results
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isFetching = false
        })
    },
    searchStart: debounce (function () {
      this.fetchPatients()
    }, 750),
    addExistingPatient () {
      if (this.objPatient) {
        this.patient = this.objPatient.id
        this.openRegisterPatientDialogVersion()
      }
    },
    addNewPatient () {
      this.prefillData = null
      this.patient = null
      this.openRegisterPatientDialogVersion()
    },
    closeDialog () {
      this.showDialog = false
    },
    processCardData (data) {
      if (data.id) {
        this.patient = data.id
        this.openRegisterPatientDialogVersion()
      } else {
        this.prefillData = data
        this.patient = null
        this.openRegisterPatientDialogVersion()
      }
    },
    openRegisterPatientDialogVersion () {
      if (this.member.extra_data?.new_registration) {
        this.openRegisterPatientDialog = true
        return
      }
      this.openOldRegisterPatientDialog = true
    },
    handleUpgraded () {
      this.openOldRegisterPatientDialog = false
      this.openRegisterPatientDialogVersion()
      this.showMessage(['success', 'New registration page enabled'])
    },
    handleDowngraded () {
      this.openRegisterPatientDialog = false
      this.openRegisterPatientDialogVersion()
      this.showMessage(['success', 'Old registration page enabled'])
    }
  }
}
</script>